import React, { useState, useEffect, useRef, useCallback } from "react";
import { onAuthStateChanged } from "firebase/auth";

import { auth, SignOutUser } from "../firebase";
import SnackbarHooks from "./shared/snackbarHooks";
import { get } from "../server-requests/serverRequests";
import { getTranslation } from "./languageProvider";
import { Log } from "./shared/utility";
import { InProgress } from "./shared/loading";

export const AuthContext = React.createContext();

const checkForByPassEmail = (user) => {
  let emailList = process.env.REACT_APP_BYPASS_EMAIL
    ? process.env.REACT_APP_BYPASS_EMAIL
    : "";
  if (user.emailVerified) return true;
  if (!user.emailVerified && emailList === "") return false;
  emailList.replace(" ", "");
  emailList.split(",");
  return emailList.includes(user.email);
};

export const AuthProvider = ({ children }) => {
  const snackbarRef = useRef();

  const [user, setUser] = useState(null);
  const [appUser, setAppUser] = useState(null);
  const [userVerified, setUserVerified] = useState(true);
  const [authLoading, setAuthLoading] = useState(true);

  const snackbarHandler = useCallback((message, type = "errors", action) => {
    if (action) {
      snackbarRef.current.Open(message, type, action);
    } else {
      snackbarRef.current.Open(message, type);
    }
  }, []);

  const logoutHandler = useCallback(() => {
    setUser(null);
    setAppUser(null);
    SignOutUser("notSignIn").catch((status) =>
      snackbarHandler(getTranslation(`error${status}`))
    );
  }, [snackbarHandler]);

  useEffect(() => {
    if (authLoading) {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          setUser(user);
          let isVerified = checkForByPassEmail(user);
          setUserVerified(isVerified);
          if (isVerified && !appUser) {
            get("accounts")
              .then((appUserData) => {
                if (
                  appUserData.role.code !==
                  Number(process.env.REACT_APP_MANAGER)
                ) {
                  logoutHandler();
                  snackbarHandler(getTranslation(`0083`));
                } else {
                  setAppUser(appUserData);
                }
                setAuthLoading(false);
              })
              .catch((status) => {
                logoutHandler();
                Log("error on accounts");
                snackbarHandler(getTranslation(`error${status}`));
                setAuthLoading(false);
              });
          } else {
            setAuthLoading(false);
          }
        } else {
          setAuthLoading(false);
        }
      });
    }
  }, [authLoading, appUser, snackbarHandler, logoutHandler]);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        userVerified,
        appUser,
        setAppUser,
        authLoading,
        setAuthLoading,
        snackbarHandler,
        logoutHandler,
      }}
    >
      {authLoading ? <InProgress /> : children}
      <SnackbarHooks ref={snackbarRef} />
    </AuthContext.Provider>
  );
};
